/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

import type { AddExtraMealRequest } from "../models/AddExtraMealRequest";
import type { AddMealToSlotRequest } from "../models/AddMealToSlotRequest";
import type { ConfirmSwapRequest } from "../models/ConfirmSwapRequest";
import type { DataMessageResponse_dict_ } from "../models/DataMessageResponse_dict_";
import type { DataMessageResponse_list_MealSwapFilterOptionWithSubFilters__ } from "../models/DataMessageResponse_list_MealSwapFilterOptionWithSubFilters__";
import type { DataMessageResponse_MealSuggestions_ } from "../models/DataMessageResponse_MealSuggestions_";
import type { DataMessageResponse_NutritionalInfoResponse_ } from "../models/DataMessageResponse_NutritionalInfoResponse_";
import type { DataMessageResponse_Plan_ } from "../models/DataMessageResponse_Plan_";
import type { DataResponse_List_str__ } from "../models/DataResponse_List_str__";
import type { DataResponse_PlanStreaks_ } from "../models/DataResponse_PlanStreaks_";
import type { MessageOnlyResponse } from "../models/MessageOnlyResponse";
import type { RecalibratePlanRequest } from "../models/RecalibratePlanRequest";
import type { RecalibratePlanResponse } from "../models/RecalibratePlanResponse";
import type { RemoveExtraMealRequest } from "../models/RemoveExtraMealRequest";
import type { RemoveMealFromSlotRequest } from "../models/RemoveMealFromSlotRequest";
import type { RepeatMealOnDaysRequest } from "../models/RepeatMealOnDaysRequest";
import type { SkipMealRequest } from "../models/SkipMealRequest";
import type { UndoSwapRequest } from "../models/UndoSwapRequest";
import type { UnskipMealRequest } from "../models/UnskipMealRequest";
import type { UpdateMealRequest } from "../models/UpdateMealRequest";
import type { UpdateMealTickedOffRequest } from "../models/UpdateMealTickedOffRequest";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class PlansService {
  /**
   * Generate Plan
   * Generate a meal plan based on all meal suggestions
   * @param xUserId
   * @returns DataMessageResponse_Plan_ Successful Response
   * @throws ApiError
   */
  public static generatePlanApiV1PlansPut(
    xUserId: string,
  ): CancelablePromise<DataMessageResponse_Plan_> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/plans",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Plan
   * Get the user's meal plan with two weeks of events applied, plus an
   * optional previous week.
   *
   * Returns Plan with plan=[WeekPlan("1"), WeekPlan("2")], each with its own
   * meals, nutrition, and dayDate fields. Permanent events (swaps, recalibration)
   * apply to both weeks; week-scoped events (skips, tick-offs) are per-week.
   *
   * The optional previousWeek field holds a folded WeekPlan("0") for the
   * previous ISO week when the active plan was created on or before that
   * week's Monday. It is null when the plan was generated this week (fresh
   * onboarding or regeneration) and there is no coherent history to show.
   * @param xUserId
   * @returns DataMessageResponse_Plan_ Successful Response
   * @throws ApiError
   */
  public static getPlanApiV1PlansGet(
    xUserId: string,
  ): CancelablePromise<DataMessageResponse_Plan_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/plans",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Nutritional Info
   * Get nutritional information from the user's meal plan.
   *
   * CRITICAL: This endpoint applies temporary swaps to ensure accurate nutrition data.
   * The stored nutrition in DynamoDB may be stale when temporary swaps exist.
   * @param xUserId
   * @returns DataMessageResponse_NutritionalInfoResponse_ Successful Response
   * @throws ApiError
   */
  public static getNutritionalInfoApiV1PlansNutritionalInfoGet(
    xUserId: string,
  ): CancelablePromise<DataMessageResponse_NutritionalInfoResponse_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/plans/nutritional-info",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Meal In Plan
   * Update a meal in the user's active meal plan via the event architecture.
   *
   * Creates an immutable MealReplaced event immediately (no temp-then-confirm flow).
   * Checks calorie deviation and returns is_undoable flag for the frontend.
   * Undo is handled by DELETE /meal/swap which creates a compensating event.
   * @param xUserId
   * @param requestBody
   * @returns DataMessageResponse_dict_ Successful Response
   * @throws ApiError
   */
  public static updateMealInPlanApiV1PlansMealPut(
    xUserId: string,
    requestBody: UpdateMealRequest,
  ): CancelablePromise<DataMessageResponse_dict_> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/plans/meal",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Remove Meal From Slot
   * Remove a meal from a specific meal-time slot (undo counterpart of POST /plans/meals).
   *
   * Creates an immutable MealRemoved event with scope="permanent", origin="undo",
   * is_extra=False. Cancels a permanent add going forward — the meal will no
   * longer appear in this week or subsequent weeks.
   * @param xUserId
   * @param requestBody
   * @returns MessageOnlyResponse Successful Response
   * @throws ApiError
   */
  public static removeMealFromSlotApiV1PlansMealDelete(
    xUserId: string,
    requestBody: RemoveMealFromSlotRequest,
  ): CancelablePromise<MessageOnlyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/plans/meal",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Confirm Meal Swap
   * No-op — swaps are now applied immediately via the event architecture.
   * Kept for backward compatibility. Returns the current plan.
   * @param xUserId
   * @param requestBody
   * @returns DataMessageResponse_dict_ Successful Response
   * @throws ApiError
   */
  public static confirmMealSwapApiV1PlansMealSwapConfirmPost(
    xUserId: string,
    requestBody: ConfirmSwapRequest,
  ): CancelablePromise<DataMessageResponse_dict_> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/plans/meal/swap/confirm",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Undo Meal Swap
   * Undo a meal swap by creating a compensating MealReplaced event.
   *
   * The frontend sends the original_meal_id to restore. A new MealReplaced event
   * is created that swaps back to the original meal. Events are immutable —
   * undo is a new fact, not a deletion.
   * @param xUserId
   * @param requestBody
   * @returns DataMessageResponse_dict_ Successful Response
   * @throws ApiError
   */
  public static undoMealSwapApiV1PlansMealSwapDelete(
    xUserId: string,
    requestBody: UndoSwapRequest,
  ): CancelablePromise<DataMessageResponse_dict_> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/plans/meal/swap",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Add Extra Meal
   * Add an extra meal to a plan day for the current week (week-scoped).
   *
   * Creates an immutable MealAdded event with scope="week". The extra meal
   * automatically disappears next week. Use DELETE /meal/add to undo.
   * The frontend refetches the full plan after this call.
   * @param xUserId
   * @param requestBody
   * @returns MessageOnlyResponse Successful Response
   * @throws ApiError
   */
  public static addExtraMealApiV1PlansMealAddPost(
    xUserId: string,
    requestBody: AddExtraMealRequest,
  ): CancelablePromise<MessageOnlyResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/plans/meal/add",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Remove Extra Meal
   * Remove an extra meal from a plan day (undo add).
   *
   * Creates an immutable MealRemoved event with scope="week" and origin="undo".
   * The frontend refetches the full plan after this call.
   * @param xUserId
   * @param requestBody
   * @returns MessageOnlyResponse Successful Response
   * @throws ApiError
   */
  public static removeExtraMealApiV1PlansMealAddDelete(
    xUserId: string,
    requestBody: RemoveExtraMealRequest,
  ): CancelablePromise<MessageOnlyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/plans/meal/add",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Add Meal To Slot
   * Add a meal to a specific meal-time slot (breakfast / lunch / dinner / snack) for a plan day.
   *
   * Mirrors PUT /plans/meal: creates an immutable MealAdded event (permanent, origin=user,
   * is_extra=False), checks calorie deviation, and returns the updated plan with
   * needs_adjustment / is_undoable flags so the frontend can prompt undo if the add
   * pushes the day out of bounds. The add persists across weeks — the meal appears
   * in this week and every subsequent week until explicitly removed via DELETE /plans/meal.
   *
   * User-initiated adds allow duplicates: adding the same meal twice to the same
   * (day, mealTime) results in two occurrences. Only recalibration-origin adds are
   * deduplicated (see PlanAggregate._evolve_added).
   * @param xUserId
   * @param requestBody
   * @returns DataMessageResponse_dict_ Successful Response
   * @throws ApiError
   */
  public static addMealToSlotApiV1PlansMealsPost(
    xUserId: string,
    requestBody: AddMealToSlotRequest,
  ): CancelablePromise<DataMessageResponse_dict_> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/plans/meals",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Repeat Meal On Slots
   * Repeat a meal across multiple weekdays at the same meal-time slot.
   *
   * For each weekday in `days`, emits a permanent MealAdded event (origin=user,
   * is_extra=False) so the meal appears in that (weekday, mealTime) slot every
   * week going forward. Weekdays that have already passed within the reference
   * week bump their `valid_from` to the next ISO week — current-week past
   * slots stay untouched but every future week receives the meal.
   *
   * Per-day persistence is best-effort: if a single event write fails, the
   * loop continues and the failing day is returned in `skipped_days`. Input
   * validation errors (malformed command, meal not found) fail the whole
   * request.
   * @param xUserId
   * @param requestBody
   * @returns DataMessageResponse_dict_ Successful Response
   * @throws ApiError
   */
  public static repeatMealOnSlotsApiV1PlansMealsRepeatPost(
    xUserId: string,
    requestBody: RepeatMealOnDaysRequest,
  ): CancelablePromise<DataMessageResponse_dict_> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/plans/meals/repeat",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Meal Ticked Off Status
   * Update the ticked-off status of a meal via the event architecture.
   *
   * Creates immutable MealConsumed/MealUnconsumed events in PlanEventsTable.
   * Weekly reset is automatic: events are week-scoped, new week = no events = all unticked.
   * @param xUserId
   * @param requestBody
   * @returns MessageOnlyResponse Successful Response
   * @throws ApiError
   */
  public static updateMealTickedOffStatusApiV1PlansMealTickPatch(
    xUserId: string,
    requestBody: UpdateMealTickedOffRequest,
  ): CancelablePromise<MessageOnlyResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v1/plans/meal/tick",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Recalibrate Plan
   * Manually recalibrate the user's meal plan to maintain nutritional boundaries.
   *
   * Week selection:
   * Mon–Thu: recalibrates plan[0] (current week) with permanent events.
   * Fri–Sun: recalibrates plan[1] (next week) via two-step process:
   * Step 1: permanent recalibration if plan[1] is structurally out of bounds.
   * Step 2: week-scoped compensation for temporary deviation (skips/adds).
   * @param xUserId
   * @param requestBody
   * @returns RecalibratePlanResponse Successful Response
   * @throws ApiError
   */
  public static recalibratePlanApiV1PlansRecalibratePost(
    xUserId: string,
    requestBody: RecalibratePlanRequest,
  ): CancelablePromise<RecalibratePlanResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/plans/recalibrate",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Plan Streaks
   * Get streak and completion metrics for the user's meal plan.
   *
   * This endpoint calculates:
   * - currentStreakDays: Consecutive days with all meals ticked off
   * - weeklyCompletionDays: Days in current week with all meals completed
   * - daysSinceFirstPlan: Days since user received their first plan
   * - firstPlanDate: ISO date of user's first plan
   * - isPlanFullyCompleted: Whether all meals in the plan have been ticked off
   * - completedDays: List of day names for days where all meals are ticked off
   *
   * Streak calculation considers both original meals and temporary swaps.
   * A day is "complete" only when ALL meals for that day are ticked off.
   * All metrics exclude future days (only count days up to and including today).
   *
   * Args:
   * request: FastAPI request object
   * x_user_id: User ID from authentication token
   *
   * Returns:
   * PlanStreaks object with all streak and completion metrics
   *
   * Raises:
   * HTTPException 404: If no active plan found
   * HTTPException 500: On calculation errors
   * @param xUserId
   * @returns DataResponse_PlanStreaks_ Successful Response
   * @throws ApiError
   */
  public static getPlanStreaksApiV1PlansStreaksGet(
    xUserId: string,
  ): CancelablePromise<DataResponse_PlanStreaks_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/plans/streaks",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Meal Alternatives
   * Get meal alternatives using meal-aware calorie range with gentle targeting.
   *
   * Filters meals based on the current meal being replaced with optional filter, sub-filter, brand, and semantic search filtering.
   *
   * ## Query Parameters:
   * - **meal_id**: ID of the meal to find alternatives for (required)
   * - **meal_time**: Time of meal - breakfast, lunch, dinner, or snack (required)
   * - **day_of_week**: Day of week for the meal in the plan - monday through sunday (optional, but recommended for accurate tracking)
   * - **filter**: Filter for meal alternatives (optional)
   * - 'recipes' (non-branded home meals)
   * - 'branded' (branded products)
   * - 'outAndAbout' (coffee shops and quick bites)
   * - **sub_filter**: Sub-filter for meal alternatives (requires filter parameter)
   * - 'similar' (uses original meal for similarity search)
   * - 'yourFoods' (user's custom meals, requires parent filter)
   * - 'myFavourites' (user's favorite meals, requires parent filter)
   * - Semantic search tags: 'porridge', 'eggs', 'sandwiches', 'chicken', etc. (meal-time-specific)
   * - Note: sub-filters are meal-time-specific and use semantic search while respecting the filter constraint
   * - **from_brand**: Filter to show meals from specific brands (optional, supports multiple brands with OR logic)
   * - **search**: Free-text semantic search query (optional)
   * - Examples: 'chicken pasta', 'high protein breakfast', 'low carb vegetarian'
   * - When provided, performs semantic search instead of using user's meal preferences
   *
   * ## Examples:
   * - Get all alternatives: `/meal-alternatives?meal_id=123&meal_time=breakfast&day_of_week=monday`
   * - Recipes only: `/meal-alternatives?meal_id=123&meal_time=breakfast&day_of_week=monday&filter=recipes`
   * - Branded products: `/meal-alternatives?meal_id=123&meal_time=breakfast&day_of_week=monday&filter=branded`
   * - Out & About: `/meal-alternatives?meal_id=123&meal_time=breakfast&day_of_week=monday&filter=outAndAbout`
   * - Recipes with chicken: `/meal-alternatives?meal_id=123&meal_time=lunch&day_of_week=monday&filter=recipes&sub_filter=chicken`
   * - Your Foods: `/meal-alternatives?meal_id=123&meal_time=lunch&day_of_week=monday&filter=recipes&sub_filter=yourFoods`
   * - Similar meals: `/meal-alternatives?meal_id=123&meal_time=breakfast&day_of_week=monday&filter=recipes&sub_filter=similar`
   * - Using brand filter: `/meal-alternatives?meal_id=123&meal_time=breakfast&day_of_week=monday&from_brand=Starbucks`
   * - Multiple brands (OR): `/meal-alternatives?meal_id=123&meal_time=breakfast&day_of_week=monday&from_brand=Starbucks&from_brand=Pret`
   * - Using semantic search: `/meal-alternatives?meal_id=123&meal_time=breakfast&day_of_week=monday&search=high+protein+pancakes`
   * Returns:
   * Filtered meal suggestions with meal-aware calorie range that provides variety while gently guiding toward calorie goals
   * @param mealId ID of the meal in the plan to find alternatives for
   * @param mealTime Meal time (breakfast, lunch, dinner, snack)
   * @param xUserId
   * @param dayOfWeek Day of week for the meal in the plan (monday, tuesday, wednesday, thursday, friday, saturday, sunday). Recommended for accurate tracking when same meal appears on multiple days.
   * @param filter Filter for meal alternatives. Options: 'recipes' (non-branded), 'branded' (branded products), 'outAndAbout' (coffee shops).
   * @param subFilter Sub-filter for meal alternatives (requires filter parameter). Examples: 'similar', 'porridge', 'chicken', 'sandwiches' (meal-time-specific semantic search tags). Note: 'similar' uses original meal for similarity search.
   * @param fromBrand Filter results to show meals from specific brands (e.g., 'Starbucks', 'Pret', 'Caffè Nero'). Can specify multiple brands for OR logic.
   * @param search Free-text search query for semantic meal search (e.g., 'chicken pasta', 'high protein breakfast'). When provided, overrides user's meal preferences for the search.
   * @param isExtra True if the reference meal lives in day_plan.extraMeals (added via POST /meal/add) rather than the regular meal-time slot.
   * @param targetDate ISO date (YYYY-MM-DD) of the day being inspected. Determines which week's plan is read when looking up the reference meal. Defaults to current week if omitted.
   * @returns DataMessageResponse_MealSuggestions_ Successful Response
   * @throws ApiError
   */
  public static getMealAlternativesApiV1PlansMealAlternativesGet(
    mealId: string,
    mealTime: string,
    xUserId: string,
    dayOfWeek?: string | null,
    filter?: string | null,
    subFilter?: string | null,
    fromBrand?: Array<string> | null,
    search?: string | null,
    isExtra: boolean = false,
    targetDate?: string | null,
  ): CancelablePromise<DataMessageResponse_MealSuggestions_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/plans/meal-alternatives",
      headers: {
        "x-user-id": xUserId,
      },
      query: {
        meal_id: mealId,
        meal_time: mealTime,
        day_of_week: dayOfWeek,
        filter: filter,
        sub_filter: subFilter,
        from_brand: fromBrand,
        search: search,
        isExtra: isExtra,
        target_date: targetDate,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Meal Alternatives Filter Options
   * Get meal swap filter options with nested hierarchical structure.
   *
   * Returns all filter categories with their meal-time-specific sub-filters.
   * Filters are mutually exclusive - frontend sends ONE filter value at a time to /meal-alternatives.
   *
   * ### Top-level Filters:
   * - **Recipes** (recipes) - Non-branded home cooking and fresh meals
   * - **Branded** (branded) - Supermarket branded products
   * - **Out & About** (outAndAbout) - Coffee shops, restaurants, and grab-and-go
   *
   * ### Sub-filters:
   * When `meal_time` is provided, sub-filters are tailored to that meal time:
   *
   * **Recipes**:
   * - Breakfast: Your Foods, Liked Foods, Similar, Porridge, Eggs, Overnight Oats, Weetabix
   * - Lunch: Your Foods, Liked Foods, Similar, Sandwiches, Wraps, Soups, Salad
   * - Dinner: Your Foods, Liked Foods, Similar, Chicken, Fajitas, Tacos, Burgers
   * - Snack: Your Foods, Liked Foods, Similar, Protein, Crisps, Sweet, Nuts, Cheese
   *
   * **Branded**:
   * - Breakfast: Your Foods, Liked Foods, Similar, Porridge, Cereal, Weetabix
   * - Lunch: Your Foods, Liked Foods, Similar, Sandwiches, Wraps, Soups, Salad
   * - Dinner: Your Foods, Liked Foods, Similar, Chicken, Fish, Burgers, Sausages
   * - Snack: Your Foods, Liked Foods, My Favourites, Similar, Protein, Crisps, Sweet, Ice Cream
   *
   * **Out & About**:
   * - Breakfast: Your Foods, Liked Foods, Porridge, Pastries, Bagel, Coffee, Eggs
   * - Lunch: Your Foods, Liked Foods, Sandwiches, Wraps, Soups, Salad, Panini's
   * - Dinner: Nando's, Pizza Express, Burgers, Wraps & Bowls, Itsu
   *
   * Returns:
   * List of filter options with nested subFilters structure
   * @param xUserId
   * @param mealTime Meal time for meal-time-specific sub-filters (breakfast, lunch, dinner, snack)
   * @returns DataMessageResponse_list_MealSwapFilterOptionWithSubFilters__ Successful Response
   * @throws ApiError
   */
  public static getMealAlternativesFilterOptionsApiV1PlansAlternativesFiltersGet(
    xUserId: string,
    mealTime?: string | null,
  ): CancelablePromise<DataMessageResponse_list_MealSwapFilterOptionWithSubFilters__> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/plans/alternatives/filters",
      headers: {
        "x-user-id": xUserId,
      },
      query: {
        meal_time: mealTime,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Search Tags
   * Get predefined search tags for a specific meal time.
   *
   * Returns a list of popular meal search terms that users can use to discover
   * meals in the meal database for the specified meal time.
   *
   * Args:
   * meal_time: The meal time (breakfast, lunch, dinner, snack)
   *
   * Returns:
   * List of search tag strings
   *
   * Raises:
   * HTTPException 400: If invalid meal_time provided
   * @param mealTime Meal time to get search tags for (breakfast, lunch, dinner, snack)
   * @returns DataResponse_List_str__ Successful Response
   * @throws ApiError
   */
  public static getSearchTagsApiV1PlansAlternativesSearchTagsGet(
    mealTime: string,
  ): CancelablePromise<DataResponse_List_str__> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/plans/alternatives/search-tags",
      query: {
        meal_time: mealTime,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Regenerate Plan
   * Regenerate the meal plan from existing meal suggestions.
   * Creates a new optimized plan based on the user's current nutritional requirements and preferences.
   * @param xUserId
   * @returns DataMessageResponse_Plan_ Successful Response
   * @throws ApiError
   */
  public static regeneratePlanApiV1PlansRegeneratePut(
    xUserId: string,
  ): CancelablePromise<DataMessageResponse_Plan_> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/plans/regenerate",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Skip Meal
   * Skip a meal for the current week. The meal remains visible but is marked as skipped,
   * and its calories/macros are subtracted from the daily and weekly nutrition totals.
   * @param xUserId
   * @param requestBody
   * @returns DataMessageResponse_dict_ Successful Response
   * @throws ApiError
   */
  public static skipMealApiV1PlansMealSkipPost(
    xUserId: string,
    requestBody: SkipMealRequest,
  ): CancelablePromise<DataMessageResponse_dict_> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/plans/meal/skip",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Unskip Meal
   * Unskip a previously skipped meal by creating a compensating 'unskipped' event.
   * Restores the meal's calories/macros to the daily and weekly nutrition totals.
   * Events are immutable — unskip is a new fact, not a deletion of the skip.
   * @param xUserId
   * @param requestBody
   * @returns DataMessageResponse_dict_ Successful Response
   * @throws ApiError
   */
  public static unskipMealApiV1PlansMealSkipDelete(
    xUserId: string,
    requestBody: UnskipMealRequest,
  ): CancelablePromise<DataMessageResponse_dict_> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/plans/meal/skip",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
